import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  logo: {
    width: 235,
    height: 56,
    borderRight: `1px solid ${token.colorSplit}`,
    transition: 'width 0.2s',
    paddingInline: 4
  },
  collapsedLogo: {
    width: 49,
    height: 56,
    borderRight: `1px solid ${token.colorSplit}`,
    transition: 'width 0.2s',
    paddingInline: 4
  },
  title: {
    opacity: '1,',
    transition: 'opacity 0.2s',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  collapseTitle: {
    display: 'none',
    opacity: 0,
    transition: 'opacity 0.2s'
  },
  text: {
    overflow: 'hidden'
  },
  organizationSelect: {
    marginLeft: 24,
    '.ant-select-selector': {
      height: '40px !important',
      width: '200px !important',
      border: 'none !important',
      cursor: 'pointer !important'
    }
  },
  orgIcon: {
    objectFit: 'contain'
  }
}))
